/**
 * The five steps of listen & write design §3, one screen each, in the
 * classroom sequence's order (§1): gist, with the text, dictation,
 * reconstruction, feedback.
 */
export const STEPS = ['listen', 'transcript', 'dictation', 'write', 'feedback'] as const;
export type Step = (typeof STEPS)[number];

export function stepNumber(step: Step): number {
  return STEPS.indexOf(step) + 1;
}

/**
 * Nothing is required to move on (§3: "Next" is always enabled, nothing is
 * scored). Writing is left only by handing it in, which is its own button
 * gated on the word count, not a Next.
 */
export function canAdvance(step: Step): boolean {
  return step === 'listen' || step === 'transcript' || step === 'dictation';
}

export function nextStep(step: Step): Step | null {
  return canAdvance(step) ? STEPS[STEPS.indexOf(step) + 1] : null;
}

/**
 * Back is allowed (§3) until the retelling is handed in. Past that the row
 * exists and its feedback is on its way; going back to edit would hand in a
 * second retelling, a second spend of the 30-an-hour limit (§10.8), rather
 * than change the first.
 */
export function canGoBack(step: Step): boolean {
  return step !== 'listen' && step !== 'feedback';
}

export function previousStep(step: Step): Step | null {
  return canGoBack(step) ? STEPS[STEPS.indexOf(step) - 1] : null;
}
